"use client";

import React, { useEffect } from "react";
import "./event.css";
import { Image } from "react-bootstrap";

// Component starts here
export default function EventsPage() {
  useEffect(() => {
    // This effect runs on the client after the component mounts
    const letters = document.querySelectorAll(".letter");
    letters.forEach((letter, index) => {
      setTimeout(() => {
        letter.classList.add("show");
      }, index * 100); // delay for sequential effect
    });
  }, []); // Empty dependency array ensures this runs only once

  const metaTags = {
    title: "CodeQlik Events - INDIA SOFT 2025",
    description:
      "Join us at INDIA SOFT 2025, India's premier software and technology exhibition. Discover the latest innovations and connect with industry leaders. CodeQlik is proud to be a part of this prestigious event.",
    keywords:
      "india soft 2025, technology conference, software exhibition, codeqlik events, it conference, technology event",
    image: "/assets/img/india_soft_2025.jpg",
    url: "https://codeqlik.com/events",
  };

  return (
    <>
      <div>
        <div className="container event_working">
          <span className="tm-hero-subtitle">EVENTS </span>
          <div className="evnet glow" id="text">
            <span className="letter">I</span>
            <span className="letter">N</span>
            <span className="letter">D</span>
            <span className="letter">I</span>
            <span className="letter">A</span>
            <span className="letter"> </span>
            <span className="letter">S</span>
            <span className="letter">O</span>
            <span className="letter">F</span>
            <span className="letter">T</span>
            <span className="letter"> </span>
            <span className="letter">2</span>
            <span className="letter">0</span>
            <span className="letter">2</span>
            <span className="letter">5</span>
          </div>
        </div>

        <div className="container-fluid">
          <div className="masonry-container">
            {/* All image paths are updated to point to the /public directory */}
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025.jpg"
                  alt="India Soft 2025 Event Image 1"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_1.jpg"
                  alt="India Soft 2025 Event Image 2"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_2.jpg"
                  alt="India Soft 2025 Event Image 3"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_3.jpg"
                  alt="India Soft 2025 Event Image 4"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_4.jpg"
                  alt="India Soft 2025 Event Image 5"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_5.jpg"
                  alt="India Soft 2025 Event Image 6"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_6.jpg"
                  alt="India Soft 2025 Event Image 7"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_7.jpg"
                  alt="India Soft 2025 Event Image 8"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_8.jpg"
                  alt="India Soft 2025 Event Image 9"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_9.jpg"
                  alt="India Soft 2025 Event Image 10"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_10.jpg"
                  alt="India Soft 2025 Event Image 11"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_11.jpg"
                  alt="India Soft 2025 Event Image 12"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_12.jpg"
                  alt="India Soft 2025 Event Image 13"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_13.jpg"
                  alt="India Soft 2025 Event Image 14"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_14.jpg"
                  alt="India Soft 2025 Event Image 15"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_15.jpg"
                  alt="India Soft 2025 Event Image 16"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_16.jpg"
                  alt="India Soft 2025 Event Image 17"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_17.jpg"
                  alt="India Soft 2025 Event Image 18"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
            <div className="masonry-item">
              <span>
                <Image
                  src="/assets/img/india_soft_2025_18.jpg"
                  alt="India Soft 2025 Event Image 19"
                />
                <Image
                  className="logo"
                  src="/assets/img/CodeQlik_logo.png"
                  alt="Logo"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
